"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerableCustomerHistoryPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var VulnerableCustomerHistoryGrid_1 = require("./VulnerableCustomerHistoryGrid");
var operators_1 = require("rxjs/operators");
var Pagination_1 = require("../../helpers/Pagination");
var VulnerableCustomerHistoryPagePlain = /** @class */ (function (_super) {
    __extends(VulnerableCustomerHistoryPagePlain, _super);
    function VulnerableCustomerHistoryPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.loading = function () {
            return _this.state.loadingQueueSize !== 0 && !_this.state.additionalSupportRecords;
        };
        _this.state = {
            additionalSupportRecords: {
                count: 0,
                results: []
            },
            limit: 4,
            offset: 0,
            loading: false,
            noResultError: false,
            loadingQueueSize: 0
        };
        _this.handleClickPrevious = _this.handleClickPrevious.bind(_this);
        _this.handleClickNext = _this.handleClickNext.bind(_this);
        _this.handleClickPageNumber = _this.handleClickPageNumber.bind(_this);
        return _this;
    }
    VulnerableCustomerHistoryPagePlain.prototype.componentDidMount = function () {
        this.fetchRecordsForOffset(this.state.offset);
    };
    VulnerableCustomerHistoryPagePlain.prototype.render = function () {
        document.title = "Additional support history";
        if (this.templates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Support", "Read_Only"])) {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: !this.loading }), this.templates.renderHeader(), this.templates.renderBackLink("Customer details", true, "/customers/".concat(this.props.params.id)), this.state.loading ? this.templates.renderSpinner() : this.state.noResultError ?
                        (0, jsx_runtime_1.jsxs)("div", { className: "alert alert-danger", children: ["No results for ", this.props.params.policyNumber, " found"] }) :
                        (0, jsx_runtime_1.jsx)(VulnerableCustomerHistoryGrid_1.default, { additionalSupportRecords: this.state.additionalSupportRecords }), (0, jsx_runtime_1.jsx)(Pagination_1.default, { limit: this.state.limit, offset: this.state.offset, total: this.state.additionalSupportRecords.count, onClickPrevious: this.handleClickPrevious, onClickNext: this.handleClickNext, onClickPageNumber: this.handleClickPageNumber }), this.templates.renderFooter()] }));
        }
        else {
            return this.templates.renderErrorPage();
        }
    };
    VulnerableCustomerHistoryPagePlain.prototype.fetchRecordsForOffset = function (offset) {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getAdditionalSupportRecordHistory(_this.props.params.policyNumber, _this.props.params.id, _this.state.limit, offset)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (results) {
                _this.saveResultsToState(results);
            });
        });
    };
    VulnerableCustomerHistoryPagePlain.prototype.saveResultsToState = function (results) {
        var _this = this;
        this.supportPortalService.getAdditionalSupportRecordHistoryRecordCount(this.props.params.policyNumber, this.props.params.id).subscribe(function (count) {
            _this.setState({
                additionalSupportRecords: {
                    count: count,
                    results: results
                },
                noResultError: results.length === 0
            });
        });
    };
    VulnerableCustomerHistoryPagePlain.prototype.handleClickPrevious = function () {
        var _this = this;
        this.setState(function (state) {
            var offset = state.offset;
            var newOffset = state.offset - state.limit;
            if (newOffset >= 0) {
                offset = newOffset;
            }
            _this.fetchRecordsForOffset(offset);
            return { offset: offset };
        });
    };
    VulnerableCustomerHistoryPagePlain.prototype.handleClickNext = function () {
        var _this = this;
        this.setState(function (state) {
            var offset = state.offset;
            var newOffset = state.offset + state.limit;
            if (newOffset < state.additionalSupportRecords.count) {
                offset = newOffset;
            }
            _this.fetchRecordsForOffset(offset);
            return { offset: offset };
        });
    };
    VulnerableCustomerHistoryPagePlain.prototype.handleClickPageNumber = function (pageNumber) {
        var _this = this;
        this.setState(function (state) {
            var offset = state.offset;
            var newOffset = state.limit * (pageNumber - 1);
            if (newOffset >= 0 && newOffset < state.additionalSupportRecords.count) {
                offset = newOffset;
            }
            _this.fetchRecordsForOffset(offset);
            return { offset: offset };
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], VulnerableCustomerHistoryPagePlain.prototype, "supportPortalService", void 0);
    VulnerableCustomerHistoryPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], VulnerableCustomerHistoryPagePlain);
    return VulnerableCustomerHistoryPagePlain;
}(React.Component));
exports.VulnerableCustomerHistoryPagePlain = VulnerableCustomerHistoryPagePlain;
exports.default = (0, components_1.withRouter)(VulnerableCustomerHistoryPagePlain);
//# sourceMappingURL=VulnerableCustomerHistoryPage.js.map